import { useRef } from 'react'

import { ScreenReaderNotifier } from '@/legacy/components/ScreenReaderNotifier'
import { BodyM, HeadingS } from '@/legacy/components/Typography'

import { usePartnerSearch } from '../core/PartnerSearchContext'
import { ListPartnerStyle } from '../styles'

import PartnerListItem from './PartnerListItem'

const ResultPartner = () => {
  const { sortedPartners, inputSearchPartner, shouldEnableNotifier, settingsLink } =
    usePartnerSearch()

  const hasResultsPartners = !!sortedPartners.length
  const titleResult = `Resultados da busca pelo termo "${inputSearchPartner}".`
  const titleNoResult = `Não encontramos nenhum resultado para "${inputSearchPartner}".`
  const partnerRef = useRef<HTMLButtonElement>(null)

  if (shouldEnableNotifier) {
    setTimeout(() => {
      partnerRef.current?.focus()
    }, 100)
  }

  return (
    <>
      {inputSearchPartner && hasResultsPartners && (
        <>
          <HeadingS className="result-search-partner space">{titleResult}</HeadingS>
          <ScreenReaderNotifier
            label={titleResult}
            enabled={shouldEnableNotifier}
            allowSuppressOtherElements={false}
          />
        </>
      )}

      <ListPartnerStyle hasPartner={hasResultsPartners}>
        {hasResultsPartners ? (
          sortedPartners.map((partner, index) => (
            <PartnerListItem
              key={`lpartner_item_${partner.name}_${index}`}
              ref={partnerRef}
              index={index}
              {...partner}
            />
          ))
        ) : (
          <>
            <HeadingS className="result-search-partner ">{titleNoResult}</HeadingS>
            <ScreenReaderNotifier
              label={titleNoResult}
              enabled={shouldEnableNotifier}
              allowSuppressOtherElements={false}
            />
            <BodyM className="result-option" color="dark-high">
              Por favor, altere os termos e busque novamente, ou {''}
              <a href={settingsLink.link} className="access-partner">
                {settingsLink.label}
              </a>
            </BodyM>
          </>
        )}
      </ListPartnerStyle>
    </>
  )
}
export default ResultPartner
